module.exports = __webpack_public_path__ + "static/img/index2(1)_03.6ea9e0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index2(1)_03.png
// module id = 3120
// module chunks = 1